import { FC } from 'react';
import { CheckboxField, useControlledField } from '@frontend/design-system';
import { CategoryOption } from '../../../../../../types/form-template.types';
import { checkboxContainerStyle } from '../checklist-field/checklist-field.styles';

interface InlineCategorizedChecklistProps {
  categoryId: string;
  options: CategoryOption[];
  fieldId: string;
  value: string[];
  onChange: (newValue: string[]) => void;
  onBlur: () => void;
}

const InlineCategoryOption: FC<{
  option: CategoryOption;
  categoryId: string;
  fieldId: string;
  isChecked: boolean;
  onToggle: (optionValue: string, checked: boolean) => void;
}> = ({ option, categoryId, fieldId, isChecked, onToggle }) => {
  const checkboxProps = useControlledField({
    type: 'checkbox',
    value: isChecked,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    onChange: (checked: boolean) => onToggle(option.value!, checked),
  });

  return (
    <CheckboxField
      {...checkboxProps}
      name={`${fieldId}-${categoryId}-opt-${option.value}`}
      label={option.label ?? ''}
    />
  );
};

export const InlineCategorizedChecklist: FC<InlineCategorizedChecklistProps> = ({
  categoryId,
  options,
  fieldId,
  value,
  onChange,
  onBlur,
}) => {
  const handleToggle = (optionValue: string, checked: boolean) => {
    const newValue = checked ? [...(value || []), optionValue] : (value || []).filter((v) => v !== optionValue);
    onChange(newValue);
    onBlur();
  };

  return (
    <div css={checkboxContainerStyle}>
      {options.map((option) => {
        if (!option || !option.value) {
          return null;
        }

        const isChecked = (value || []).includes(option.value);

        return (
          <InlineCategoryOption
            key={`${categoryId}-opt-${option.value}`}
            option={option}
            categoryId={categoryId}
            fieldId={fieldId}
            isChecked={isChecked}
            onToggle={handleToggle}
          />
        );
      })}
    </div>
  );
};
